import type { TableView } from "owa-mail-list-store";
import { MailRowDataPropertyGetter, getSelectedTableView } from "owa-mail-list-store";
import type { ClientItem, ClientMessage } from "owa-mail-store";
import type { ClientItemId } from "owa-client-ids";
import { getStore as getMailStore } from "owa-mail-store/lib/store/Store";
import getActiveSecondaryReadingPaneTabItemId from "owa-tab-store/lib/utils/getActiveSecondaryReadingPaneTabItemId";
import { getSingleSelectedItemFromView } from "./getSelectedItemFromView";

export interface SelectedTeamsActionContext {
    item: ClientItem | undefined;
    senderName: string;
}

export function getSelectedTeamsActionContext(itemId?: ClientItemId, effectiveTableView?: TableView): SelectedTeamsActionContext {
    const tableView = effectiveTableView ??
        (!itemId ? getSelectedTableView(true /* shouldGetEffectiveTableView */) : undefined);
    
    const item = getSelectedTeamsActionItem(itemId, tableView);
    const senderNameFromItem = (item as ClientMessage | undefined)?.From?.Mailbox?.Name;
    if (senderNameFromItem) {
        return {
            item,
            senderName: senderNameFromItem,
        };
    }
    
    if (itemId || !tableView) {
        return {
            item,
            senderName: "",
        };
    }
    
    const rowKeys = tableView.isInVirtualSelectAllMode
        ? tableView.rowKeys
        : [...tableView.selectedRowKeys.keys()];
    const selectedRowKey = rowKeys.length === 1 ? rowKeys[0] : undefined;
    
    return {
        item,
        senderName: selectedRowKey
            ? (MailRowDataPropertyGetter.getLastSenderMailbox(selectedRowKey, tableView)?.Name ??
                "")
            : "",
    };
}

export function getSelectedTeamsActionItem(itemId?: ClientItemId, effectiveTableView?: TableView): ClientItem | undefined {
    if (itemId) {
        return getMailStore().items.get(itemId.Id);
    }
    
    const activeSecondaryReadingPaneItemId = getActiveSecondaryReadingPaneTabItemId();
    if (activeSecondaryReadingPaneItemId) {
        return getMailStore().items.get(activeSecondaryReadingPaneItemId);
    }
    
    return getSingleSelectedItemFromView(effectiveTableView ?? getSelectedTableView(true /* shouldGetEffectiveTableView */));
}
